export default {
    // Header Section
    "discover_your": "Discover Your",
    "sadesati": "SadeSati",
    "saturn_influence_analysis": "Saturn's Influence Analysis",
    "sadesati_description": "Get a detailed analysis of Saturn’s influence on your life, with insights and remedies to turn challenges into opportunities for growth and success.",

    "sadesati_your": "SadeSati Analysis",
    // Service Information
    "enter_details_for_sadesati": "Enter Your Details for SadeSati Analysis",
    "complete_sadesati_analysis": "Complete SadeSati Analysis",
    "service_price": "Service Price",
    "comprehensive_sadesati_analysis_note": "Deep analysis of Saturn's transit effects and personalized remedial guidance",

    // Form Fields
    "full_name": "Full Name",
    "enter_full_name": "Enter your full name",
    "name_saturn_influence": "Your name vibrations interact with Saturn's energy patterns",
    "email_address": "Email Address",
    "enter_email_address": "Enter your email address",
    "phone_number": "Phone Number",
    "enter_phone_number": "Enter your phone number",
    "gender": "Gender",
    "male": "Male",
    "female": "Female",
    "other": "Other",
    "date_of_birth": "Date of Birth",
    "birth_date_moon_position": "Essential for determining your Moon sign and SadeSati phase",
    "time_of_birth": "Time of Birth",
    "exact_time_critical_for_sadesati": "Precise time needed for accurate Moon sign calculation",
    "place_of_birth": "Place of Birth",
    "place_of_birth_placeholder": "City, State, Country",
    "location_essential_for_sadesati": "Location coordinates affect planetary calculations",
    "preferred_language": "Preferred Language",
    "english": "English",
    "hindi": "Hindi",
    "telugu": "Telugu",
    "kannada": "Kannada",
    "language_note": "Your SadeSati analysis will be delivered in the selected language",

    // Core SadeSati Features
    "sadesati_phase_identification": "SadeSati Phase Identification",
    "saturn_effects_analysis": "Saturn's Effects Analysis",
    "remedies_and_solutions": "Remedies & Solutions",
    "timeline_predictions": "Timeline Predictions",
    "life_guidance_during_sadesati": "Life Guidance During SadeSati",
    "pdf_download": "Comprehensive PDF Report",

    "what_you_get": "What Your SadeSati Analysis Includes",
    "complete_sadesati_timeline": "Complete SadeSati Timeline",
    "saturn_influence_analysis": "Saturn's Influence Analysis",
    "personalized_remedies": "Personalized Remedies",
    "life_guidance_insights": "Life Guidance & Insights",

    // Actions & Buttons
    "pay_and_generate_analysis": "Get My SadeSati Analysis",
    "processing_payment": "Processing Payment",
    "processing_request": "Generating Analysis",

    // Payment & Success Messages
    "thank_you": "Thank You",
    "payment_successful": "Payment Successful!",
    "sadesati_analysis_processing": "Your SadeSati analysis is being prepared by our expert Vedic astrologers. You'll receive detailed insights into Saturn's current influence on your life.",
    "order_id": "Order ID",
    "payment_id": "Payment ID",
    "amount_paid": "Amount Paid",

    // Delivery Information
    "delivery_information": "Delivery Information",
    "delivery_time": "Analysis Delivery",
    "within_12_hours_delivery_note": "Your detailed SadeSati report will be ready within 12 hours",
    "whatsapp_notification": "WhatsApp Updates",
    "whatsapp_delivery_note": "Receive instant notifications on WhatsApp",
    "email_delivery": "Email Delivery",
    "email_delivery_note": "Complete analysis delivered to",

    // What You'll Receive
    "what_youll_receive": "Your SadeSati Analysis Package",
    "detailed_sadesati_report": "Comprehensive SadeSati Report (PDF)",
    "saturn_phase_analysis": "Saturn Phase & Timeline Analysis",
    "remedial_measures_guidance": "Remedial Measures & Guidance",
    "life_predictions_timeline": "Life Predictions & Timeline",
    "spiritual_guidance_saturn": "Spiritual Guidance for Saturn Period",

    // Visual Content
    "sample_sadesati_analysis": "Sample SadeSati Analysis",
    "sadesati_phase": "SadeSati Phase",
    "sample_sadesati_description": "Currently in Peak Phase - Maximum Saturn influence period",
    "sample_sadesati_preview": "Preview of your personalized SadeSati analysis with phase details",
    "sadesati_phases": "SadeSati Phases",

    // SadeSati Phase Types
    "rising_phase": "Rising Phase",
    "peak_phase": "Peak Phase", 
    "setting_phase": "Setting Phase",

    // Status & Processing
    "your_sadesati_analysis_status": "Your SadeSati Analysis Status",
    "processing_your_analysis": "Analyzing Saturn's Influence",
    "analysis_processing_message": "Our Vedic astrology experts are studying Saturn's current position and its effects on your life path.",
    "request_id": "Analysis ID",
    "status": "Status",
    "processing": "In Progress",
    "pending": "Queued",
    "email_notification_sent": "Confirmation email sent",
    "whatsapp_update_coming": "WhatsApp updates enabled",
    "delivery_within_12_hours": "Report ready within 12 hours",

    // Support & Contact
    "contact_support": "Contact Astrology Support",
    "need_help": "Need guidance?",
    "contact_us_at": "Reach us at",

    // Error Messages
    "please_fill_all_required_fields": "Please complete all required birth details",
    "payment_failed": "Payment unsuccessful. Please try again.",
    "processing_failed": "Analysis processing failed. Contact our support team.",

    // SadeSati-Specific Elements
    "saturn_transit": "Saturn Transit",
    "moon_sign": "Moon Sign (Rashi)",
    "saturn_position": "Saturn's Current Position",
    "sadesati_duration": "SadeSati Duration",
    "phase_timeline": "Phase Timeline",
    "saturn_effects": "Saturn's Effects",

    // Phase Analysis
    "first_phase": "First Phase (2.5 years)",
    "second_phase": "Second Phase (2.5 years)",
    "third_phase": "Third Phase (2.5 years)",
    "phase_characteristics": "Phase Characteristics",
    "phase_challenges": "Phase Challenges",
    "phase_opportunities": "Phase Opportunities",

    // Effects & Influences
    "career_effects": "Career & Professional Effects",
    "health_effects": "Health & Well-being Effects",
    "relationship_effects": "Relationship Effects",
    "financial_effects": "Financial Impact",
    "mental_effects": "Mental & Emotional Effects",
    "spiritual_effects": "Spiritual Growth Effects",

    // Remedies & Solutions
    "saturn_remedies": "Saturn Remedies",
    "gemstone_recommendations": "Gemstone Recommendations",
    "mantra_chanting": "Mantra Chanting",
    "fasting_recommendations": "Fasting Guidelines",
    "charity_suggestions": "Charitable Activities",
    "worship_rituals": "Worship Rituals",
    "lifestyle_changes": "Lifestyle Modifications",

    // Timeline & Predictions
    "current_phase": "Current Phase",
    "remaining_duration": "Remaining Duration",
    "next_phase_start": "Next Phase Start Date",
    "sadesati_end_date": "SadeSati End Date",
    "monthly_predictions": "Monthly Predictions",
    "yearly_overview": "Yearly Overview",

    // Detailed Analysis Sections
    "saturn_mythology": "Saturn in Vedic Mythology",
    "karmic_lessons": "Karmic Lessons",
    "past_life_karma": "Past Life Karma",
    "spiritual_significance": "Spiritual Significance",
    "growth_opportunities": "Growth Opportunities",
    "life_lessons": "Life Lessons from Saturn",

    // Practical Guidance
    "do_and_dont": "Do's and Don'ts During SadeSati",
    "precautions": "Precautions to Take",
    "best_practices": "Best Practices",
    "meditation_practices": "Meditation Practices",
    "yoga_recommendations": "Yoga Recommendations",
    "dietary_guidelines": "Dietary Guidelines",

    // Support & Guidance
    "coping_strategies": "Coping Strategies",
    "stress_management": "Stress Management",
    "emotional_support": "Emotional Support Techniques",
    "family_guidance": "Family Relationship Guidance",
    "professional_guidance": "Professional Life Guidance",

    // Advanced Analysis
    "saturn_aspects": "Saturn's Aspects",
    "planetary_combinations": "Planetary Combinations",
    "dasha_analysis": "Dasha Period Analysis",
    "transit_effects": "Transit Effects",
    "yogas_formed": "Yogas Formed with Saturn"
};
